export const TITLE = "Proposal Sections Assignment";
export const SUBTITLE = "Sections assigned per person";
export const EMPTY_HEADING = "No sections assigned yet";
export const EMPTY_BODY = "As proposal outline sections are assigned, they will appear here.";
